import { marketAsyncComponent } from '@/utils/asyncComponent';
if ($ADMIN_BASE_ENV === 'gray') {
    window.branch_env = 'gray';
    if (window.vhtml_market_env_components === undefined) {
        window.vhtml_market_env_components = ['aside-nav'];
    } else if (Array.isArray(window.vhtml_market_env_components) && !window.vhtml_market_env_components.includes('aside-nav')) {
        window.vhtml_market_env_components.push('aside-nav');
    }
}
export default marketAsyncComponent('aside-nav', '0.0.2', { crossorigin: 'anonymous' });
